import { RigidBody } from '@react-three/rapier';

export default function PhysicsFloor({ children }) {
	return (
		<RigidBody type="fixed" colliders="cuboid">
			{children}
		</RigidBody>
	);
}
